import clsx from 'clsx';
import React from 'react';
import { FiMinus } from 'react-icons/fi';
import { RoundCrossIcon } from '../../../Assets/icons';
import classes from './Pills.module.css';
import { MinusIcon } from '../../../Assets/icons';
const Pills = ({
  label = '',
  selected,
  data,
  onClick,
  onCancel,
  cross = false,
  clickAreaAll = false,
  onMinus,
  onAdd,
  ...rest
}) => {
  return (
    <span
      className={clsx(classes.wrapper, { [classes.selected]: selected })}
      onClick={() => {
        clickAreaAll && onClick && onClick();
        if (typeof onAdd === 'function') {
          onAdd();
        }
      }}
      {...rest}>
      {label}

      {onMinus && (
        <span
          className={classes.roundMinus}
          onClick={(e) => {
            e.stopPropagation();
            if (typeof onMinus === 'function') {
              onMinus();
            }
            if (typeof onCancel === 'function') {
              onCancel();
            }
          }}>
          <MinusIcon />
          {/* <FiMinus strokeWidth="5" className={classes.minus} color="#fff" size={8} /> */}
        </span>
      )}
      {/* {cross && (
        <span
          onClick={(e) => {
            e.stopPropagation();
            if (typeof onClick === 'function') {
              onClick();
            }
            if (typeof onCancel === 'function') {
              onCancel();
            }
          }}
          
          >
          <RoundCrossIcon />
        </span>
      )} */}
    </span>
  );
};

export default Pills;
